import { graphQlClient } from "lib/graphql-client.js";
import Layout from "../components/Layout";
import PageIntro from "components/content/PageIntro/PageIntro";
import { fetchLayoutData, fetchLayoutDataServer } from "lib/api/strapi-layout";

const Terms = ({ termData, layoutData }) => {
  return (
    <Layout seo={termData?.seo} layoutData={layoutData}>
      <div className="variable-container">
        <PageIntro
          title={termData?.page_intro?.page_title}
          description={termData?.page_intro?.description ?? ""}
        />

        <div
          dangerouslySetInnerHTML={{
            __html: termData?.content,
          }}
        />

        <p>
          <strong>Updated at:</strong> {termData?.updated_at}
        </p>
      </div>
    </Layout>
  );
};

export default Terms;

export async function getStaticProps() {
  const { gql } = await import("@apollo/client");
  const { default: MarkdownIt } = await import("markdown-it");

  const strapiApolloClient = graphQlClient();

  const md = new MarkdownIt();
  const { data } = await strapiApolloClient.query({
    query: gql`
      query TermsPageQuery {
        term {
          data {
            attributes {
              content
              updatedAt
              slug
              page_intro {
                page_title
                page_introduction
              }
              search_engine_optimization {
                meta {
                  title
                  content
                }
                metaDescription
                metaTitle
                preventIndexing
                metaMedia {
                  data {
                    attributes {
                      url
                      alternativeText
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
  });
  const content = data?.term?.data?.attributes;

  const termData = {
    page_intro: { ...content.page_intro },
    seo: {
      ...content.search_engine_optimization,
      metaMedia: {
        ...content.search_engine_optimization.metaMedia.data.attributes,
      },
    },
    content: md.render(content?.content),
    updated_at: new Date(content?.updatedAt).toLocaleDateString("default", {
      month: "long",
      day: "numeric",
      year: "numeric",
    }),
  };

  // const layoutData = await fetchLayoutData();
  const layoutData = await fetchLayoutDataServer();

  return {
    props: { termData, layoutData },
  };
}
